import { useEffect } from 'react';

import { cx } from '@emotion/css';
import { Button, Flex } from '@revenuemarket/cds';
import { CloseX } from '@revenuemarket/ui';
import { Modal, ModalProps } from 'antd';

import { css } from '~libs/emotion';

interface Props extends ModalProps {
  closeElement?: React.ReactNode;
}

const CommonModal: React.FC<Props> = ({
  title,
  closable = true,
  closeElement,
  className,
  style,
  onOk,
  onCancel,
  ...props
}) => {
  useEffect(() => {
    // esc 눌렀을시에 모달 닫히도록
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        //@ts-ignore
        onCancel?.(e);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onCancel]);

  useEffect(() => {
    // enter 눌렀을시에 props.onOk 실행
    const handleEnterKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        //@ts-ignore
        onOk?.(e);
      }
    };

    window.addEventListener('keydown', handleEnterKeyDown);
    return () => {
      window.removeEventListener('keydown', handleEnterKeyDown);
    };
  }, [onOk]);

  return (
    <Modal
      className={cx(
        css`
          &&& .ant-modal-content {
            border-radius: 20px;
            padding: 20px;
            background: #fff;
          }
          &&& .ant-modal-close {
            visibility: hidden;
          }
        `,
        className,
      )}
      style={{
        borderRadius: 20,
        ...style,
      }}
      title={
        closable ? (
          <Flex
            align="center"
            justify="space-between"
            className={css`
              font-size: 16px;
            `}
          >
            {title}
            {closeElement ? (
              closeElement
            ) : (
              <Button
                onClick={onCancel}
                border
                buttonType="weak"
                icon={<CloseX width={18} height={18} />}
              />
            )}
          </Flex>
        ) : (
          title
        )
      }
      onCancel={onCancel}
      onOk={onOk}
      {...props}
    />
  );
};

export default CommonModal;
